import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import useAuthStore from "../store/authStore";
import "./ProductDetail.css";

const API_URL = process.env.REACT_APP_BASE_URL || "http://localhost:3337";

const ProductDetailPetrolier = () => {
  const { id } = useParams();
  const { role, isAuthenticated, token } = useAuthStore();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error404, setError404] = useState(false);

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        setLoading(true);
        setError404(false);
        const response = await axios.get(`${API_URL}/api/petrolier/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setProduct(response.data);
      } catch (err) {
        console.error("Erreur getProductById :", err);
        if (err.response?.status === 404) setError404(true);
      } finally {
        setLoading(false);
      }
    };
    fetchProduct();
  }, [id, token]);

  const imageSrc = product?.image?.startsWith?.("http")
    ? product.image
    : `${API_URL}${product?.image || ""}`;

  const pdfPath = product?.pdf || product?.specifications?.PDF || "";
  const pdfHref = pdfPath
    ? pdfPath?.startsWith?.("http") ? pdfPath : `${API_URL}${pdfPath}`
    : "";

  return (
    <>
      <section className="pd-hero">
        <div className="pd-hero__content">
          <h1 className="pd-hero__title">Détail du Produit</h1>
          <div className="pd-hero__breadcrumb">
            <Link to="/">Accueil</Link>
            <span className="pd-hero__sep">/</span>
            <Link to="/produits">Produits</Link>
            <span className="pd-hero__sep">/</span>
            <Link to="/petroliers">Pétroliers</Link>
            <span className="pd-hero__sep">/</span>
            <span className="pd-hero__current">{product?.name || "Détail"}</span>
          </div>
        </div>
      </section>

      <div className="pd-container">
        {loading ? (
          <div className="pd-card"><div className="pd-loading"><div className="pd-spinner" /></div></div>
        ) : error404 || !product ? (
          <div className="pd-card">
            <div className="pd-error">
              <div className="pd-error__icon"><i className="fas fa-exclamation-triangle" /></div>
              <div className="pd-error__title">Produit non trouvé</div>
              <div className="pd-error__text">Le produit que vous recherchez n'existe pas ou a été supprimé.</div>
            </div>
          </div>
        ) : (
          <>
            <div className="pd-card">
              <div className="pd-layout">
                <div className="pd-image-side">
                  <img className="pd-image" src={imageSrc} alt={product.name} onError={(e) => { e.currentTarget.src = "/assets/images/fallback.png"; }} />
                </div>
                <div className="pd-info-side">
                  {product.category && <span className="pd-badge">{product.category}</span>}
                  <h1 className="pd-name">{product.name}</h1>
                  {product.subCategory && (
                    <div className="pd-sub-badge"><i className="fas fa-tag" /> {product.subCategory}</div>
                  )}
                  {product.description && <p className="pd-description">{product.description}</p>}
                  {product.specifications && Object.keys(product.specifications).length > 0 && (
                    <div className="pd-specs">
                      <div className="pd-specs__title"><i className="fas fa-cogs" /> Spécifications techniques</div>
                      <div className="pd-specs__grid">
                        {Object.entries(product.specifications).filter(([key]) => key !== "PDF").map(([key, value]) => (
                          <div key={key} className="pd-specs__item">
                            <span className="pd-specs__key">{key}:</span>
                            <span className="pd-specs__val">{value}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                  <div className="pd-download">
                    {pdfHref ? (
                      isAuthenticated && (role === "admin" || role === "moderator") ? (
                        <a href={pdfHref} download className="pd-download__btn"><i className="fas fa-file-pdf" /> Télécharger la fiche technique</a>
                      ) : (
                        <div className="pd-restricted"><i className="fas fa-lock" /> Connectez-vous (Admin/Modérateur) pour télécharger la fiche technique.</div>
                      )
                    ) : (
                      <div className="pd-no-pdf"><i className="fas fa-info-circle" /> Aucune fiche technique disponible pour ce produit.</div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <Link to="/petroliers" className="pd-back"><i className="fas fa-arrow-left" /> Retour aux produits</Link>
          </>
        )}
      </div>
    </>
  );
};

export default ProductDetailPetrolier;
